<template>
  <div v-if="!!allEvents.length">
    <b-row class="booked-events-list">
      <div v-for="(event, index) in allEvents" :key="index" class="booked-event">
        <router-link :to="getRoute(event.url, event.slug)" class="to-booked-event">
          <div v-if="isMobileScreen" class="for-mobile-design">
            <div class="event-name">{{ event.name }}</div>
            <b-img :src="event.banner || event.main_banner"></b-img>
            <div class="event-info">
              <div class="event-info-city-and-date">
                <div class="event-city">{{ event.city }}</div>
                <b>
                  {{ $formatDate.getUTCDate(event.start_date) }}
                  {{ $formatDate.getUTCMonth(event.start_date) }} -
                  {{ $formatDate.getUTCDate(event.end_date) }}
                  {{ $formatDate.getUTCMonth(event.end_date) }}
                  {{ $formatDate.getUTCYear(event.end_date) }}
                </b>
              </div>
            </div>
          </div>
          <b-row v-if="!isMobileScreen" class="booked-events-profile">
            <b-col sm="1" class="event-year">

              {{ $formatDate.getUTCYear(event.start_date) }}
            </b-col>
            <b-col sm="1" class="forEventDate">
              <p class="eventDate" :style="'color: #5cb85c'
    ">
                {{ $formatDate.getUTCDate(event.start_date) }}
                {{ $formatDate.getUTCMonth(event.start_date) }}
                <br />⌄<br />
                {{ $formatDate.getUTCDate(event.end_date) }}
                {{ $formatDate.getUTCMonth(event.end_date) }}

              </p>
            </b-col>

            <b-col sm="2" class="forEventImg">
              <b-img :src="event.banner || event.main_banner"></b-img>
              <div class="booked-overlay">
                <i class="fas fa-check" />
                <div>Booked</div>
              </div>
            </b-col>
            <b-col sm="4" md="5" lg="6"  class="forEventParaghraph">
              <div class="eventTxt">{{ event.name }}</div>
              <p class="eventCity">{{ event.city }}</p>
            </b-col>
            <b-col cols="3" class="text-right pr-0 event-button-row">
              <router-link v-if="isMPEnabled(event)"
                :to="{ name: 'meetingPlanner', params: { eventId: event.id, slug: event.slug } }">
                <!-- <i class="fas fa-calendar-alt mpIcon" /> -->
                <button class="meetingPlanner">
                <b-row id="event-button-row" class="m-0">
                  <b-col sm="4" class="eventCalendar">
                    <i class="fa fa-calendar"></i>
                  </b-col>
                  <b-col sm="2" class="meetingPlannerText">Online Meeting Planner available</b-col>
                </b-row>
              </button>
              </router-link>
              <button class="mp-button" v-else-if="isEvent(event.url)"  disabled>
                <i class="fa fa-calendar"></i> Online Meeting Planner is not available
              </button>
              <button class="meetingPlanner" v-else="isAward(event.url)">Event Page </button>
            </b-col>
          </b-row>
        </router-link>

      </div>
    </b-row>
  </div>
  <div v-else>
    <div class="no-events">
      No events found
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import EventButtons from './EventButtons.vue';
import { getOwnerId } from '@/utils/getOwnerId';
import getIDfromURL from '@/utils/getIDfromURL';

export default {
  name: 'EventList',
  data() {
    return {
      allEntities: [],
      allEvents: [],
      invoices: [],
    };
  },
  components: {
    EventButtons,
  },
  computed: {
    ...mapGetters({
      activeEvents: 'events/activeEvents',
      events: 'events/fetchEvents',
      userInfo: 'user/fetchUserInfo',
      isMobileScreen: 'isMobileScreen',
    }),
  },
  async mounted() {
    await this.fetchBookedEvents(this.$route.params.customerId || getOwnerId()).then((res) => {
      this.allEvents.push(...res);
    });
    await this.fetchBookedAwards(this.$route.params.customerId || getOwnerId()).then((res) => {
      this.allEvents.push(...res);
    });
    await this.fetchPaymentEntities().then(
      ({ results }) => (this.allEntities = results),
    );
    await this.fetchUserInvoices(this.userInfo.id).then(
      ({ results }) => (this.invoices = results),
    );
  },

  methods: {
    ...mapActions({
      fetchPaymentEntities: 'companies/fetchPaymentEntities',
      fetchUserInvoices: 'user/fetchUserInvoices',
      fetchBookedEvents: 'events/fetchBookedEvents',
      fetchBookedAwards: 'awards/fetchBookedAwards',
    }),
    moment(date) {
      return moment(new Date(date).toUTCString());
    },
    getRoute(url, slug = '') {
      let route;
      const id = getIDfromURL(url);
      if (url.includes('events')) {
        route = { name: 'standardEvent', params: { eventId: id, slug: slug } };
      }
      if (url.includes('awards')) {
        route = { name: 'globalAwardsEvents', params: { awardId: id, slug } };
      }
      return route;
    },
    isMPEnabled(event) {
      return this.isEvent(event.url)
        && event.meeting_planner_is_active
        && this.isMpActive(event.meeting_planner_is_active, event.meeting_planner_activation_date)
        && event.display_participants
        && this.isAvailable(event.participant_customers);
    },
    isEvent(url) {
      return url.includes('events');
    },
    isMpActive(isActive, activitionDate) {
      return (
        isActive
          ? moment(moment(new Date().toUTCString()).format('YYYY-MM-DD')).isSameOrAfter(
            moment(activitionDate).format('YYYY/MM/DD'),
          )
          : moment(
            moment(new Date().toUTCString()).add(21, 'days').format('YYYY-MM-DD'),
          ).isSameOrAfter(moment(activitionDate).format('YYYY/MM/DD'))
      );
    },
    isAvailable(participants) {
      let available = false;
      participants.forEach(({ customer_id, display }) => {
        if (customer_id === getOwnerId()) available = display;
      });
      return available;
    },
    isAward(url) {
      return url.includes('awards');
    },
  },
};
</script>

<style scoped>
.meetingPlanner {
  background: #f5f5dc00;
  width: 80px;
  font-size: 9px;
  padding: 5px 1px;
  border: 1px solid #bd9d5f;
  color: #bd9d5f;
  line-height: 1.1;
}
</style>
<style src="@/components/bookedEvents/css/booked-event.css" scoped></style>
<style src="./css/event-list.css" scoped></style>
<style scoped>
   .booked-events-profile {
    padding: 0;
    margin-bottom: 10px;
    border-bottom-left-radius: 10px;
   }
   .meetingPlanner {
    margin-top: 15px;
   }
   .for-mobile-design {
    margin-bottom: 15px;
   }
   .meetingPlanner {
  background: #f5f5dc00;
  width: 80px;
  font-size: 9px;
  padding: 5px 1px;
  border: 1px solid #bd9d5f;
  color: #bd9d5f;
  line-height: 1.1;
}
.meetingPlanner:hover {
  background: #bd9d5f;
  color: white;
  transition: 0.3s;
}
.meetingPlannerText:hover {
  margin-left: -14px;
  color: white;
}
.meetingPlanner > i {
  font-size: 21px;
}
.eventCalendar {
  padding: 1px;
  margin-left: 3px;
  font-size: 16px;
}
.meetingPlannerText {
  margin-left: -14px;
}
.mp-button {
  margin-top: 20px;
  padding: 0;
  width: 80px;
  font-size: 9px;
  border: none;
  color: #7f7f7f;
}
.mp-button:focus {
  outline: none;
}
</style>
